import React from "react";
import Button from "@mui/material/Button";
import { CircularProgress } from "@mui/material";

const CustomButton = ({ onClick, variant, label, loading,disabled }) => {
  const buttonStyles = {
    backgroundColor: variant === "cancel" ? "#737D86" : variant === "warning"?"#EF7D00":"#112A63",
    fontWeight: 600,
    width: "8.125rem",
    height: "3.375rem",
    borderRadius: "0.625rem",
     "&.Mui-disabled": {
      backgroundColor: "#102A62",
      color: "#ffffff",
      opacity: 0.6,
    },
  };

  return (
    <Button
      sx={buttonStyles}
      variant="contained"
      onClick={onClick}
      disabled={loading || disabled}
    >
      {loading && <CircularProgress size={20} />}
      {label}
    </Button>
  );
};

export default CustomButton;
